module.exports = __webpack_public_path__ + "202408221624/img/img_upload_120@2x.d57b682a.png";